// The service worker's registration (INSTALL.md §4.2).
//
// ON LOAD, NOT ON A TAP. Push registered it only when somebody turned
// notifications on (PLAN-2026-09-26-bell B3), which was enough while the
// worker did nothing else. It holds the app shell now (scenario M1), and the
// shell is what makes a cold start with no signal show the app rather than
// the browser's error page — which only helps if the worker is there before
// the signal goes. Registering asks nothing of the person: the permission
// prompt is still push's, after a tap (`data/push.ts`).
//
// After the page has loaded, so the worker's own downloads never compete with
// the first screen's.

export const WORKER_URL = '/sw.js';

export function registerWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const go = () => {
    navigator.serviceWorker.register(WORKER_URL).catch((e: unknown) => {
      // Not the person's problem and nothing they can do about it: the app
      // works without the worker, and it cannot be installed or work offline.
      console.error('[sw] the service worker did not register:', e);
    });
  };
  if (document.readyState === 'complete') go();
  else window.addEventListener('load', go, { once: true });
}
